import { TextPropsTextConfig } from '../types';

export const ZERO_WIDTH_SPACE = '\u200B';

export const blankLine: TextPropsTextConfig = {
  text: ZERO_WIDTH_SPACE,
  options: { breakLine: true },
};
